
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Resources from './_resources.mdx';
import Checklist from './_checklist.mdx';
import Cta from '@/partials/Cta'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Here is the toolkit to develop your Hotel Marketplace Platform",
  "date": "2021-08-18"
};
const slug = 'hotel-marketplace-app';
const tableOfContents = [{
  "title": "Hotel",
  "slug": "hotel",
  "children": []
}, {
  "title": "Hotel: Listing Categories",
  "slug": "hotel-listing-categories",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Looking to build a Hotel marketplace and apps? Here is the toolkit to launch any marketplace without writing a single line of code.`}</p>
    <p>{`Tradly Platform has a simple user interface to build any marketplace like Hotel marketplace and launch your marketplace with our no-code and low code software. It is a complete white label solution…`}</p>
    <p>{`The marketplace can be built on any platform, whether it is Android or iOS. Along with this option, you also get a web app template to get started.`}</p>
    <p>{`Here is an example of how you can configure the catalog, listing fields in your marketplace…`}</p>
    <Cta mdxType="Cta" />
    <_Heading level={2} id={"hotel"} nextElement={{
      "type": "jsx"
    }}>Hotel</_Heading>
    <img src={require('../img/tradly/Hotel_Booking-600x450.png').default} width="700" />
    <p><a parentName="p" {...{
        "href": "https://dribbble.com/shots/14646942-Booking-App"
      }}>{`https://dribbble.com/shots/14646942-Booking-App`}</a></p>
    <_Heading level={2} id={"hotel-listing-categories"} nextElement={{
      "type": "paragraph"
    }}>Hotel: Listing Categories</_Heading>
    <p>{`Popular Hotel Types `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Independent Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Resort  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Airport Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Motel`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Chain Scales `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Luxury Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Upscale Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Midscale Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Economy Hotel  `}</li>
        </ul>
      </li>
    </ul>
    <p>{`Star Ratings `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`3-Star Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`4-Star Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`5-Star Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`7-Star Hotel  `}</li>
        </ul>
      </li>
    </ul>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Niche Hotel types`}</li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Beach Resort  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Eco Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Business Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Family Hotel  `}</li>
        </ul>
      </li>
    </ul>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Regional Accommodations`}</li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Country House Hotel `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Casa Particular  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Bunkhouse  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Albergo Diffuso  `}</li>
        </ul>
      </li>
    </ul>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Unique Hotel Concepts `}</p>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Capsule Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Castle Hotel  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Hotelship  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Hotel Barge  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Hotel Alternatives `}</p>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Cabin  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Campsite  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Farm Stay  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Guesthouse`}</li>
        </ul>
      </li>
    </ul>
    <Checklist mdxType="Checklist" />
    <Cta mdxType="Cta" />
    <Resources mdxType="Resources" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
